export default __webpack_public_path__ + "static/media/MK.ac8190dc.png";